import axios from 'axios';
import { AppSettings } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
    START_LOADING,
    STOP_LOADING,
    GET_REPORT_ON_SCREEN,
    GET_EXPORT_REPORT,
    GET_REPORT_OUTSTANDING_ON_SCREEN,
    GET_EXPORT_OUTSTANDING_REPORT,
} 
from '../actions/actionTypes';

export function searchReportAction(serachCondition) {
    
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/GetMyTaskReport`,
                data: serachCondition
               
            })

            promise.then(response => {
                dispatch({
                    type: GET_REPORT_ON_SCREEN,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}

export function exportReportAction(serachCondition) {
    console.log('exportReportAction')
    console.log(serachCondition)
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/GetMyTaskReportExcel`,
                data: serachCondition
               
            })

            promise.then(response => {
                dispatch({
                    type: GET_EXPORT_REPORT,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}

export function getDetailLogBOTAction(transaction_no) {
    
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: authHeader(),
                method: "get",
                url: `${AppSettings.apiUrl}/api/Mytask/GetDetailLogBOT`,
                params: {
                    transaction_no : transaction_no
                }
               
            })

            promise.then(response => {
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}

export function searchReportOutstandingAction(serachCondition) {
    
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/GetListReportOutstanding`,
                data: serachCondition
               
            })

            promise.then(response => {
                dispatch({
                    type: GET_REPORT_OUTSTANDING_ON_SCREEN,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}

export function exportReportOutstandingAction(serachCondition) {
    console.log('exportReportAction')
    console.log(serachCondition)
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/GetExcelReportOutstanding`,
                data: serachCondition
               
            })

            promise.then(response => {
                dispatch({
                    type: GET_EXPORT_OUTSTANDING_REPORT,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}